import Cookies from 'universal-cookie';
const SUBSCRIBED_COOKIE_NAME = 'saved_searches_subscribed';
const SUBSCRIBED_COOKIE_VALUE = 'true';
const cookies = new Cookies();
export const saveFirstTimeSubscribe = () => {
  const date = new Date();
  const nextYear = new Date(date.setFullYear(date.getFullYear() + 1));
  cookies.set(SUBSCRIBED_COOKIE_NAME, SUBSCRIBED_COOKIE_VALUE, {
    expires: nextYear,
    path: '/'
  });
};
export const isSavedSearchUser = () => cookies.get(SUBSCRIBED_COOKIE_NAME) === SUBSCRIBED_COOKIE_VALUE;